import { render } from "./RegionDashboardsRepresentativeAbroadInfo.vue?vue&type=template&id=3dddc584&scoped=true&ts=true"
import script from "./RegionDashboardsRepresentativeAbroadInfo.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsRepresentativeAbroadInfo.vue?vue&type=script&lang=ts"

import "./RegionDashboardsRepresentativeAbroadInfo.vue?vue&type=style&index=0&id=3dddc584&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dddc584"]])

export default __exports__